export const isInteractiveMaterial = (item: Material) => Boolean(item?.interactiveId || item?.isBundleInteractive);
